export default () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.70898 0L6.92043 0.762249C7.40745 2.51795 8.77929 3.88979 10.535 4.37681L11.2972 4.58826L10.535 4.7997C8.77929 5.28672 7.40745 6.65856 6.92043 8.41426L6.70898 9.17651L6.49754 8.41426C6.01052 6.65856 4.63868 5.28672 2.88298 4.7997L2.12073 4.58826L2.88298 4.37681C4.63868 3.88979 6.01052 2.51795 6.49754 0.762249L6.70898 0Z"
      fill="#041333"
    />
    <path
      d="M2.4707 7.05884L2.58456 7.46928C2.8468 8.41466 3.58549 9.15335 4.53087 9.41559L4.94131 9.52944L4.53087 9.6433C3.58549 9.90554 2.8468 10.6442 2.58456 11.5896L2.4707 12.0001L2.35685 11.5896C2.0946 10.6442 1.35592 9.90554 0.41054 9.6433L9.63801e-05 9.52944L0.410539 9.41559C1.35592 9.15335 2.0946 8.41466 2.35685 7.46928L2.4707 7.05884Z"
      fill="#041333"
    />
  </svg>
)
